import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Column } from 'primereact/column'
import type { LocalizedText } from '../../../lib/localizedText'
import Button from '../../../components/ui/Button'
import type { CriteriaScoreRange } from '../types'

interface ColumnOpts {
  t: TFunction
  /** İki dilli alanlar tek kolondur; değer seçili dilden gelir (`lib/localizedText`). */
  localized: LocalizedText
  onEdit: (row: CriteriaScoreRange) => void
}

/**
 * Değerlendirme Skoru tablosunun sütunları (027; paylaşılan ui/DataTable'a beslenir). **Salt liste +
 * düzenle**: TR/EN ad + başlangıç + bitiş + TR açıklama; tek "Düzenle" aksiyonu. Durum toggle / sil /
 * ↑↓ sıralama **YOK** (kayıt kümesi sabit 3 bant). Boş hücreler yer-tutucusuz bırakılır (anayasa Page
 * Standards → boş hücre gösterimi).
 */
export function criteriaScoreRangeColumns({ t, localized, onEdit }: ColumnOpts): ReactElement[] {
  return [
    <Column
      key="name"
      header={t('activity.criteriaScoreRange.columns.name')}
      body={(row: CriteriaScoreRange) => localized(row.nameTr, row.nameEn)}
    />,
    <Column
      key="startScore"
      field="startScore"
      header={t('activity.criteriaScoreRange.columns.startScore')}
      style={{ width: '9rem' }}
    />,
    <Column
      key="endScore"
      field="endScore"
      header={t('activity.criteriaScoreRange.columns.endScore')}
      style={{ width: '9rem' }}
    />,
    <Column
      key="description"
      header={t('activity.criteriaScoreRange.columns.description')}
      body={(row: CriteriaScoreRange) => localized(row.descriptionTr, row.descriptionEn)}
    />,
    <Column
      key="actions"
      header={t('activity.criteriaScoreRange.columns.actions')}
      style={{ width: '8rem' }}
      body={(row: CriteriaScoreRange) => (
        <div className="admin-row-actions">
          <Button
            icon="pi pi-pencil"
            rounded
            text
            aria-label={t('activity.criteriaScoreRange.actions.edit')}
            tooltip={t('activity.criteriaScoreRange.actions.edit')}
            tooltipOptions={{ position: 'bottom' }}
            onClick={() => onEdit(row)}
          />
        </div>
      )}
    />,
  ]
}
